<main class="page">
    <header>
      <section class="component-section">
        <div class="container shippn-homepage-container page">
          <div class="row">
            <div class="col-12">
              <lp-countries-hero [fromCountryName]="fromCountryName" [toCountryName]="toCountryName" [countryName]="countryName"></lp-countries-hero>
            </div>
          </div>
        </div>
      </section>
    </header>
  
    <section class="component-section accordion-section-bg">
      <div class="container shippn-homepage-container">
        <div class="row">
          <div class="col-12">
            <lp-countries-accordion [accordionSet]="accordionSet"></lp-countries-accordion>
          </div>
        </div>
      </div>
    </section>
  
    <section class="component-section">
      <div class="container shippn-homepage-container page">
        <div class="row">
          <lp-countries-carousel class="col-12" [carouselSlidesSet]="slideSet" [carouselTitle]="commentsSectionTitle"></lp-countries-carousel>
        </div>
      </div>
    </section>
  
    <section class="component-section accordion-section-bg">
      <div class="container shippn-homepage-container">
        <div class="row">
          <div class="col-12">
            <lp-countries-price-calculation [lang]="lang" [fromCountryCode]="fromCountryDetail.country_code" [countryCode]="toCountryDetail.country_code"></lp-countries-price-calculation>
          </div>
        </div>
      </div>
    </section>
  
    <section class="component-section">
      <div class="container shippn-homepage-container">
        <div class="row">
          <div class="col-12">
            <lp-countries-brands-grid [title]="brandsGridTitle" [brands]="brandsContent"></lp-countries-brands-grid>
          </div>
        </div>
      </div>
    </section>
  
    <section class="component-section advantages-section-bg">
      <div class="container shippn-homepage-container">
        <div class="row">
          <div class="col-12">
            <lp-countries-advantages></lp-countries-advantages>
          </div>
        </div>
      </div>
    </section>
  
    <section class="page-end page-end-bg">
      <div class="container shippn-homepage-container">
        <div class="row">
          <div class="col-12">
            <div class="page-end-wrapper">
              <div class="page-end-header">
                <h2>Unlock the Best of {{fromCountryDetail.country_code}} Shopping with Shippn</h2>
              </div>
              <div class="page-end-content">
                <p>
                  Get your favorite {{fromCountryDetail.country_name}} brands delivered to your doorstep in<span
                  *ngIf="toCountryDetail.country_name === 'United States of America' || toCountryDetail.country_name === 'United Kingdom'"> the</span> {{ toCountryDetail.country_name }}. Sign up now for unbeatable shipping rates and seamless international shopping!
                </p>
              </div>
              <div class="page-end-footer">
                <button class="page-end-cta-btn" [routerLink]="['/', lang, 'signup']">
                  Sign Up For Free
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>